import { NgModule } from "@angular/core";
import { EdpFooterModule } from "@edp-components/edp-footer/edp-footer.module";
import { LayoutComponent } from "./layout.component";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { EdpESidebarModule } from "@edp-components/edp-e-sidebar/edp-e-sidebar.module";
import { SharedModule } from "@edp-components/shared.module";
import { EdpEMenuAppModule } from "@edp-components/edp-e-menu-app/edp-e-menu-app.module";
import { EdpEMenuSwipeModule } from "@edp-components/edp-e-menu-swipe/edp-e-menu-swipe.module";
import { EdpContractConsumptionLocalModule } from "@edp-components/edp-contract-consumption-local/edp-contract-consumption-local.module";
import { EdpOverlayModule } from "@edp-components/edp-overlay/edp-overlay.module";
import { EdpEsContractConsumptionLocalModule } from "@edp-components/ES/edp-es-contract-consumption-local/edp-es-contract-consumption-local.module";
import { ConditionalRegionModule } from "@edp-directives/conditional-region/conditional-region.module";
import { EdpTermsConditionsModalModule } from "@edp-components/ES/edp-terms-conditions-modal/edp-terms-conditions-modal.module";

@NgModule({
    declarations: [LayoutComponent],
    imports: [
        CommonModule,
        RouterModule,
        EdpESidebarModule,
        EdpEMenuAppModule,
        EdpEMenuSwipeModule,
        EdpContractConsumptionLocalModule,
        EdpEsContractConsumptionLocalModule,
        SharedModule,
        EdpFooterModule,
        EdpOverlayModule,
        ConditionalRegionModule,
        EdpTermsConditionsModalModule
    ],
    exports: [LayoutComponent],
})
export class LayoutModule {}
